import React from "react";
import { Typography, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/styles";
import useTranslation from "../../hooks/useTranslation.jsx";
import { useLocation } from "react-router-dom";

const useStyles = (theme, isMobile) => ({
  title: {
    maxWidth: { xs: "292px", md: "700px", lg: "830px" },
    textAlign: { xs: "center", md: "inherit" },
    fontFamily: theme.typography.montserrat.regular,
    fontSize: { xs: "35px", md: "45px", lg: "50px", xl: "60px" },
    lineHeight: { xs: "43px", md: "57px", lg: "60px", xl: "70px" },
    mb: "1.5rem",
    mt: isMobile ? "3rem" : "7rem",
  },
  span: { fontWeight: "bold" },
  subtitle: {
    maxWidth: { xs: "268px", md: "560px", lg: "600px", xl: "650px" },
    width: "100%",
    textAlign: { xs: "center", md: "inherit" },
    fontFamily: theme.typography.montserrat.regular,
    fontSize: { xs: "18px", md: "22.5px", lg: "24px", xl: "27px" },
    lineHeight: { xs: "26px", md: "30.5px", lg: "32px", xl: "35px" },
    mb: { xs: "27px", md: "20px", lg: "20px", xl: "20px" },
  },
  benefits: {
    maxWidth: { xs: "268px", md: "560px", lg: "600px", xl: "650px" },
    width: { xs: "100%" },
    fontFamily: theme.typography.montserrat.regular,
    fontSize: { xs: "13px", md: "18px", lg: "20px", xl: "23px" },
    mb: { xs: "10px", md: "20px", lg: "20px", xl: "20px" },
    textAlign: "left",
    ml: { xs: "53px", md: "0px" },
  },
});

const HomeTitle = () => {
  const isMobile = useMediaQuery("(max-width:899px)");
  const theme = useTheme();
  const classes = useStyles(theme, isMobile);
  const { pathname } = useLocation();
  const { title, subtitle, benefits } = useTranslation(pathname, "HomeTitle");

  return (
    <>
      <Typography sx={classes.title}>
        {title[0]}
        <span style={classes.span}>
          {title[1]}.<br /> {title[2]}
        </span>
        {title[3]}
      </Typography>
      <Typography sx={classes.subtitle}>
        <span style={classes.span}>{subtitle[0]}</span>
        {subtitle[1]}
        {isMobile && <br></br>}
        {subtitle[2]}
        <span style={classes.span}>{subtitle[3]}</span>
      </Typography>
      <Typography sx={classes.benefits}>
        {isMobile ? benefits[0].mobile : benefits[0].desktop}
      </Typography>
      <Typography sx={classes.benefits}>{benefits[1]}</Typography>
    </>
  );
};
export default HomeTitle;
